// Działy w firmie
export const DEPARTMENTS = ['HR', 'KSIĘGOWOŚĆ', 'ADMINISTRACJA', 'SERWIS', 'HANDLOWY', 'ROZWOJU'];

// Stanowiska
export const POSITIONS = ['PRACOWNIK', 'KIEROWNIK', 'DYREKTOR', 'ZARZĄD'];
